import { Button } from '@hashicorp/react-mds/src/components/button'
import s from './style.module.css'

export default function ButtonBlock({ text, url, linkType }) {
	return (
		<div className={s.buttonBlock}>
			<Button title={text} url={url} linkType={linkType} />
		</div>
	)
}
